var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@web/utility';
var WhiteButton = function (props) {
    var disabled = props.disabled;
    return (_jsx("button", __assign({}, __assign({}, props), { className: classNames("inline-flex flex-1 justify-center rounded-md border shadow-sm px-4 py-2 bg-white-600 text-base font-medium text-gray sm:text-sm ".concat(props.className), disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-gray-50') }, { children: props.children })));
};
export default WhiteButton;
